import { render, staticRenderFns } from "./JMTZ.vue?vue&type=template&id=71d4cd4e&scoped=true&"
import script from "./JMTZ.vue?vue&type=script&lang=js&"
export * from "./JMTZ.vue?vue&type=script&lang=js&"
import style0 from "./JMTZ.vue?vue&type=style&index=0&id=71d4cd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d4cd4e",
  null
  
)

export default component.exports